import { BaseModel } from '@nuxtDatakodeUtils/models/BaseModel'

type GenericApplicationData = PildomModules.Generic.Data.GenericApplicationData

export class Application extends BaseModel<GenericApplicationData> {
    override endPoint: string = 'generic'
    override translationKey: string = 'applications'
    override permissionName: string = 'generic'
}
